import React from 'react';

import { ICurrency } from 'src/apis/common';
import { ICompany } from 'src/apis/Companies';
import { IMaDirectPlan } from 'src/apis/plans';
import PlanHeader from "../PlanHeader";
import PlanTiers from './PlanTiers';
import ProductsAndOverages from './ProductsAndOverages';

import './MaDirectPlan.scss'

export interface IProps {
  company: ICompany;
  currencies: ICurrency[];
  plan: IMaDirectPlan;
  includedMailSyncSeats: number|null;
}

const MaDirectPlan: React.FC<IProps> = ({currencies, plan, includedMailSyncSeats}) => {
  const unknownCurrency: ICurrency = {id: 0, code: 'UNK', symbol: '?', name: 'Unknown', unitsPerSymbol: 100};
  const currency = currencies.find(x => x.id === plan.currencyID) || unknownCurrency;
  return (
    <>
      <PlanHeader currencies={currencies} currencyID={plan.currencyID} isActive={true}/>
      <div className={'ma-direct-plan-details'}>
        <PlanTiers currency={currency} tiers={plan.tiers}/>
        <ProductsAndOverages
          currency={currency}
          productsAndOverages={plan.commonProperties}
          includedMailSyncSeats={includedMailSyncSeats}
        />
      </div>
    </>
  );

};

export default MaDirectPlan;
